import type { ReactElement } from "react";
import { ConfirmDialog } from "../molecules/index.js";
import type { ProposalApprovalConfirmationModel } from "./proposal-review.types.js";

/** The final impact summary; the host owns both the facts and the decision. */
export function ProposalApprovalConfirmation({
  open,
  model,
  onClose,
  onConfirm,
}: {
  open: boolean;
  model: ProposalApprovalConfirmationModel | undefined;
  onClose: () => void;
  onConfirm: () => void;
}): ReactElement {
  return (
    <ConfirmDialog
      open={open}
      title="Approve these actions?"
      tone="neutral"
      confirmLabel={model?.confirmLabel ?? "Approve and run"}
      cancelLabel="Back to review"
      onClose={onClose}
      onConfirm={onConfirm}
    >
      <p className="font-semibold text-pb-text">{model?.headline}</p>
      <p className="mt-2">{model?.detail}</p>
      <ul className="mt-3 max-h-[40dvh] space-y-3 overflow-y-auto break-words pe-2">
        {model?.actions.map((action) => (
          <li key={action.id}>
            <p className="font-medium text-pb-text">{action.title}</p>
            {action.detail ? <p>{action.detail}</p> : null}
          </li>
        ))}
      </ul>
    </ConfirmDialog>
  );
}
